var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _path2, _path3, _path4, _path5, _rect3, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPepperoni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 80,
    viewBox: "0 0 63 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 58,
    height: 78,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 59,
    height: 79,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 70.7021,
    r: 7.5,
    fill: "#2A7681"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 74.7021,
    r: 0.5,
    fill: "#7B2514"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 66.7021,
    r: 0.5,
    fill: "#7B2514"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 71.2021,
    r: 1,
    fill: "#D6917B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 69.2021,
    r: 1,
    fill: "#D6917B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 76.2021,
    r: 1,
    fill: "#D6917B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 72.7021,
    r: 1.5,
    fill: "#D6917B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 68.2021,
    r: 1,
    fill: "#7B2514"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.4999,
    cy: 64.7022,
    r: 7.5,
    transform: "rotate(28.5443 52.4999 64.7022)",
    fill: "#2A7681"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.8318,
    cy: 67.2603,
    r: 0.5,
    transform: "rotate(28.5443 48.8318 67.2603)",
    fill: "#7B2514"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.4114,
    cy: 61.1884,
    r: 0.5,
    transform: "rotate(28.5443 54.4114 61.1884)",
    fill: "#7B2514"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9433,
    cy: 64.4246,
    r: 1,
    transform: "rotate(28.5443 50.9433 64.4246)",
    fill: "#7B2514"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.2912,
    cy: 65.057,
    r: 1,
    transform: "rotate(28.5443 56.2912 65.057)",
    fill: "#7B2514"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.3111,
    cy: 69.7725,
    r: 1,
    transform: "rotate(28.5443 50.3111 69.7725)",
    fill: "#D6917B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6189 68.1315C54.2231 68.8592 53.3122 69.1283 52.5845 68.7324C51.8568 68.3366 51.5877 67.4257 51.9836 66.698C52.3794 65.9703 53.2723 65.8063 54 66.2021C54.7277 66.598 55.0148 67.4038 54.6189 68.1315Z",
    fill: "#D6917B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.6201,
    cy: 60.8336,
    r: 1,
    transform: "rotate(28.5443 50.6201 60.8336)",
    fill: "#D6917B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 66.5,
    r: 7.5,
    fill: "#2A7681"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 71.5,
    r: 0.5,
    fill: "#7B2514"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 62.5,
    r: 0.5,
    fill: "#7B2514"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 67,
    r: 1,
    fill: "#D6917B"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 65,
    r: 1,
    fill: "#D6917B"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 62,
    r: 1,
    fill: "#D6917B"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 68.5,
    r: 1.5,
    fill: "#D6917B"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 64,
    r: 1,
    fill: "#7B2514"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99752,
    cy: 51.9975,
    r: 7.5,
    transform: "rotate(-25.4886 9.99752 51.9975)",
    fill: "#2A7681"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.91357,
    cy: 56.4687,
    r: 0.5,
    transform: "rotate(-25.4886 9.91357 56.4687)",
    fill: "#7B2514"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.27624,
    cy: 48.3867,
    r: 0.5,
    transform: "rotate(-25.4886 8.27624 48.3867)",
    fill: "#7B2514"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.85864,
    cy: 53.0943,
    r: 1,
    transform: "rotate(-25.4886 8.85864 53.0943)",
    fill: "#D6917B"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5115,
    cy: 49.1373,
    r: 1,
    transform: "rotate(-25.4886 12.5115 49.1373)",
    fill: "#D6917B"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8157,
    cy: 56.747,
    r: 1,
    transform: "rotate(-25.4886 12.8157 56.747)",
    fill: "#D6917B"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6636,
    cy: 52.9422,
    r: 1.5,
    transform: "rotate(-25.4886 12.6636 52.9422)",
    fill: "#D6917B"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.76245,
    cy: 51.2469,
    r: 1,
    transform: "rotate(-25.4886 5.76245 51.2469)",
    fill: "#7B2514"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5882,
    cy: 56.7904,
    r: 7.5,
    transform: "rotate(67.6243 39.5882 56.7904)",
    fill: "#2A7681"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.128,
    cy: 56.4636,
    r: 0.5,
    transform: "rotate(67.6243 35.128 56.4636)",
    fill: "#7B2514"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2871,
    cy: 55.2677,
    r: 0.5,
    transform: "rotate(67.6243 43.2871 55.2677)",
    fill: "#7B2514"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5548,
    cy: 55.5937,
    r: 1,
    transform: "rotate(67.6243 38.5548 55.5937)",
    fill: "#D6917B"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.3078,
    cy: 59.4558,
    r: 1,
    transform: "rotate(67.6243 42.3078 59.4558)",
    fill: "#D6917B"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6927,
    cy: 59.3464,
    r: 1,
    transform: "rotate(67.6243 34.6927 59.3464)",
    fill: "#D6917B"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5001,
    cy: 59.4011,
    r: 1.5,
    transform: "rotate(67.6243 38.5001 59.4011)",
    fill: "#D6917B"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5677,
    cy: 52.6023,
    r: 1,
    transform: "rotate(67.6243 40.5677 52.6023)",
    fill: "#7B2514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0001 56.2022C47.4001 62.2022 42.8334 64.0355 40.5001 64.2022C39.0001 63.7022 37.5 63.4093 37.5 62.7021C37.5 61.7021 39.0001 62.2021 40.0001 61.7021C40.0001 60.7021 39.1667 60.3688 39.5001 59.7021C40.0001 59.2021 40.3239 58.0546 40.5001 57.7021C40.6763 57.3497 43.0001 57.3688 44.5001 57.7022C45.1667 56.7022 46.6001 55.0022 47.0001 56.2022Z",
    fill: "#AFBEB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4977 60.1972L45.5001 60.2021C45.5001 60.6747 45.6579 61.3243 45.5 61.7021C44.9895 62.9235 43.5296 63.4219 42.4219 63.619C41.4503 63.4263 42.5458 63.1199 42.5001 62.7021C42.4356 62.1113 42 62.7021 41.9474 62.1762C41.8828 61.5854 42.3344 61.6188 42.5001 61.2021C42.7809 60.8724 42.9125 60.4223 43.0001 60.2021C43.0877 59.9818 43.5463 59.4107 44.5071 59.505C44.8592 58.8701 45.1706 59.5174 45.4977 60.1972Z",
    fill: "#778B79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.473 69.6208C21.5963 69.1934 22.3708 70.2908 22 71.5001C23.5 72.5918 19.4678 73.9282 17.4999 74C15.8468 74.0604 14.4116 73.5564 13.5 73L13.4906 72.9872C12.5614 71.712 11.4616 70.2029 11.8706 69.6291C12.4511 68.8148 13.3824 70.0927 14.4869 70.2659C15.0673 69.4516 14.8416 69.8494 15.5 69.5C16.1974 69.3831 17.1519 69.8054 17.4999 69.6208C17.8479 69.4361 19.445 68.4787 20.473 69.6208Z",
    fill: "#AFBEB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4325 71.0929C20.0893 70.7795 21.1286 71.7859 21 72.5313C20.7257 72.9161 19.7804 73.784 19.4325 74C18 74 18.0165 73.9824 17 73.5C16.3207 72.7791 15.7371 72.898 15.9424 72.5313C16.2328 72.0128 15.5351 72.241 15.7976 71.7822C16.088 71.2636 16.4363 71.5529 16.8131 71.3098C17.2331 71.2044 17.6015 70.9143 17.8007 70.7857C17.9999 70.6572 18.7048 70.4584 19.4325 71.0929Z",
    fill: "#778B79"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 12.5,
    width: 57,
    height: 17,
    fill: "#DBA09F",
    stroke: "#DBA09F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05682 25V16.2727H6.00568C6.69034 16.2727 7.25 16.3963 7.68466 16.6435C8.12216 16.8878 8.44602 17.2188 8.65625 17.6364C8.86648 18.054 8.97159 18.5199 8.97159 19.0341C8.97159 19.5483 8.86648 20.0156 8.65625 20.4361C8.44886 20.8565 8.12784 21.1918 7.69318 21.4418C7.25852 21.6889 6.7017 21.8125 6.02273 21.8125H3.90909V20.875H5.98864C6.45739 20.875 6.83381 20.794 7.1179 20.6321C7.40199 20.4702 7.60795 20.2514 7.7358 19.9759C7.86648 19.6974 7.93182 19.3835 7.93182 19.0341C7.93182 18.6847 7.86648 18.3722 7.7358 18.0966C7.60795 17.821 7.40057 17.6051 7.11364 17.4489C6.8267 17.2898 6.44602 17.2102 5.97159 17.2102H4.11364V25H3.05682ZM13.2116 25.1364C12.581 25.1364 12.0369 24.9972 11.5795 24.7188C11.125 24.4375 10.7741 24.0455 10.527 23.5426C10.2827 23.0369 10.1605 22.4489 10.1605 21.7784C10.1605 21.108 10.2827 20.517 10.527 20.0057C10.7741 19.4915 11.1179 19.0909 11.5582 18.804C12.0014 18.5142 12.5185 18.3693 13.1094 18.3693C13.4503 18.3693 13.7869 18.4261 14.1193 18.5398C14.4517 18.6534 14.7543 18.8381 15.027 19.0938C15.2997 19.3466 15.517 19.6818 15.679 20.0994C15.8409 20.517 15.9219 21.0312 15.9219 21.642V22.0682H10.8764V21.1989H14.8991C14.8991 20.8295 14.8253 20.5 14.6776 20.2102C14.5327 19.9205 14.3253 19.6918 14.0554 19.5241C13.7884 19.3565 13.473 19.2727 13.1094 19.2727C12.7088 19.2727 12.3622 19.3722 12.0696 19.571C11.7798 19.767 11.5568 20.0227 11.4006 20.3381C11.2443 20.6534 11.1662 20.9915 11.1662 21.3523V21.9318C11.1662 22.4261 11.2514 22.8452 11.4219 23.1889C11.5952 23.5298 11.8352 23.7898 12.142 23.9688C12.4489 24.1449 12.8054 24.233 13.2116 24.233C13.4759 24.233 13.7145 24.196 13.9276 24.1222C14.1435 24.0455 14.3295 23.9318 14.4858 23.7812C14.642 23.6278 14.7628 23.4375 14.848 23.2102L15.8196 23.483C15.7173 23.8125 15.5455 24.1023 15.304 24.3523C15.0625 24.5994 14.7642 24.7926 14.4091 24.9318C14.054 25.0682 13.6548 25.1364 13.2116 25.1364ZM17.4517 27.4545V18.4545H18.4233V19.4943H18.5426C18.6165 19.3807 18.7188 19.2358 18.8494 19.0597C18.983 18.8807 19.1733 18.7216 19.4205 18.5824C19.6705 18.4403 20.0085 18.3693 20.4347 18.3693C20.9858 18.3693 21.4716 18.5071 21.892 18.7827C22.3125 19.0582 22.6406 19.4489 22.8764 19.9545C23.1122 20.4602 23.2301 21.0568 23.2301 21.7443C23.2301 22.4375 23.1122 23.0384 22.8764 23.5469C22.6406 24.0526 22.3139 24.4446 21.8963 24.723C21.4787 24.9986 20.9972 25.1364 20.4517 25.1364C20.0313 25.1364 19.6946 25.0668 19.4418 24.9276C19.1889 24.7855 18.9943 24.625 18.858 24.446C18.7216 24.2642 18.6165 24.1136 18.5426 23.9943H18.4574V27.4545H17.4517ZM18.4403 21.7273C18.4403 22.2216 18.5128 22.6577 18.6577 23.0355C18.8026 23.4105 19.0142 23.7045 19.2926 23.9176C19.571 24.1278 19.9119 24.233 20.3153 24.233C20.7358 24.233 21.0866 24.1222 21.3679 23.9006C21.652 23.6761 21.8651 23.375 22.0071 22.9972C22.152 22.6165 22.2244 22.1932 22.2244 21.7273C22.2244 21.267 22.1534 20.8523 22.0114 20.483C21.8722 20.1108 21.6605 19.8168 21.3764 19.6009C21.0952 19.3821 20.7415 19.2727 20.3153 19.2727C19.9063 19.2727 19.5625 19.3764 19.2841 19.5838C19.0057 19.7884 18.7955 20.0753 18.6534 20.4446C18.5114 20.8111 18.4403 21.2386 18.4403 21.7273ZM24.7642 27.4545V18.4545H25.7358V19.4943H25.8551C25.929 19.3807 26.0313 19.2358 26.1619 19.0597C26.2955 18.8807 26.4858 18.7216 26.733 18.5824C26.983 18.4403 27.321 18.3693 27.7472 18.3693C28.2983 18.3693 28.7841 18.5071 29.2045 18.7827C29.625 19.0582 29.9531 19.4489 30.1889 19.9545C30.4247 20.4602 30.5426 21.0568 30.5426 21.7443C30.5426 22.4375 30.4247 23.0384 30.1889 23.5469C29.9531 24.0526 29.6264 24.4446 29.2088 24.723C28.7912 24.9986 28.3097 25.1364 27.7642 25.1364C27.3438 25.1364 27.0071 25.0668 26.7543 24.9276C26.5014 24.7855 26.3068 24.625 26.1705 24.446C26.0341 24.2642 25.929 24.1136 25.8551 23.9943H25.7699V27.4545H24.7642ZM25.7528 21.7273C25.7528 22.2216 25.8253 22.6577 25.9702 23.0355C26.1151 23.4105 26.3267 23.7045 26.6051 23.9176C26.8835 24.1278 27.2244 24.233 27.6278 24.233C28.0483 24.233 28.3991 24.1222 28.6804 23.9006C28.9645 23.6761 29.1776 23.375 29.3196 22.9972C29.4645 22.6165 29.5369 22.1932 29.5369 21.7273C29.5369 21.267 29.4659 20.8523 29.3239 20.483C29.1847 20.1108 28.973 19.8168 28.6889 19.6009C28.4077 19.3821 28.054 19.2727 27.6278 19.2727C27.2188 19.2727 26.875 19.3764 26.5966 19.5838C26.3182 19.7884 26.108 20.0753 25.9659 20.4446C25.8239 20.8111 25.7528 21.2386 25.7528 21.7273ZM34.821 25.1364C34.1903 25.1364 33.6463 24.9972 33.1889 24.7188C32.7344 24.4375 32.3835 24.0455 32.1364 23.5426C31.892 23.0369 31.7699 22.4489 31.7699 21.7784C31.7699 21.108 31.892 20.517 32.1364 20.0057C32.3835 19.4915 32.7273 19.0909 33.1676 18.804C33.6108 18.5142 34.1278 18.3693 34.7188 18.3693C35.0597 18.3693 35.3963 18.4261 35.7287 18.5398C36.0611 18.6534 36.3636 18.8381 36.6364 19.0938C36.9091 19.3466 37.1264 19.6818 37.2884 20.0994C37.4503 20.517 37.5312 21.0312 37.5312 21.642V22.0682H32.4858V21.1989H36.5085C36.5085 20.8295 36.4347 20.5 36.2869 20.2102C36.142 19.9205 35.9347 19.6918 35.6648 19.5241C35.3977 19.3565 35.0824 19.2727 34.7188 19.2727C34.3182 19.2727 33.9716 19.3722 33.679 19.571C33.3892 19.767 33.1662 20.0227 33.0099 20.3381C32.8537 20.6534 32.7756 20.9915 32.7756 21.3523V21.9318C32.7756 22.4261 32.8608 22.8452 33.0312 23.1889C33.2045 23.5298 33.4446 23.7898 33.7514 23.9688C34.0582 24.1449 34.4148 24.233 34.821 24.233C35.0852 24.233 35.3239 24.196 35.5369 24.1222C35.7528 24.0455 35.9389 23.9318 36.0952 23.7812C36.2514 23.6278 36.3722 23.4375 36.4574 23.2102L37.429 23.483C37.3267 23.8125 37.1548 24.1023 36.9134 24.3523C36.6719 24.5994 36.3736 24.7926 36.0185 24.9318C35.6634 25.0682 35.2642 25.1364 34.821 25.1364ZM39.0611 25V18.4545H40.0327V19.4432H40.1009C40.2202 19.1193 40.4361 18.8565 40.7486 18.6548C41.0611 18.4531 41.4134 18.3523 41.8054 18.3523C41.8793 18.3523 41.9716 18.3537 42.0824 18.3565C42.1932 18.3594 42.277 18.3636 42.3338 18.3693V19.392C42.2997 19.3835 42.2216 19.3707 42.0994 19.3537C41.9801 19.3338 41.8537 19.3239 41.7202 19.3239C41.402 19.3239 41.1179 19.3906 40.8679 19.5241C40.6207 19.6548 40.4247 19.8366 40.2798 20.0696C40.1378 20.2997 40.0668 20.5625 40.0668 20.858V25H39.0611ZM45.9858 25.1364C45.3949 25.1364 44.8764 24.9957 44.4304 24.7145C43.9872 24.4332 43.6406 24.0398 43.3906 23.5341C43.1435 23.0284 43.0199 22.4375 43.0199 21.7614C43.0199 21.0795 43.1435 20.4844 43.3906 19.9759C43.6406 19.4673 43.9872 19.0724 44.4304 18.7912C44.8764 18.5099 45.3949 18.3693 45.9858 18.3693C46.5767 18.3693 47.0938 18.5099 47.5369 18.7912C47.983 19.0724 48.3295 19.4673 48.5767 19.9759C48.8267 20.4844 48.9517 21.0795 48.9517 21.7614C48.9517 22.4375 48.8267 23.0284 48.5767 23.5341C48.3295 24.0398 47.983 24.4332 47.5369 24.7145C47.0938 24.9957 46.5767 25.1364 45.9858 25.1364ZM45.9858 24.233C46.4347 24.233 46.804 24.1179 47.0938 23.8878C47.3835 23.6577 47.598 23.3551 47.7372 22.9801C47.8764 22.6051 47.946 22.1989 47.946 21.7614C47.946 21.3239 47.8764 20.9162 47.7372 20.5384C47.598 20.1605 47.3835 19.8551 47.0938 19.6222C46.804 19.3892 46.4347 19.2727 45.9858 19.2727C45.5369 19.2727 45.1676 19.3892 44.8778 19.6222C44.5881 19.8551 44.3736 20.1605 44.2344 20.5384C44.0952 20.9162 44.0256 21.3239 44.0256 21.7614C44.0256 22.1989 44.0952 22.6051 44.2344 22.9801C44.3736 23.3551 44.5881 23.6577 44.8778 23.8878C45.1676 24.1179 45.5369 24.233 45.9858 24.233ZM51.4925 21.0625V25H50.4869V18.4545H51.4585V19.4773H51.5437C51.6971 19.1449 51.93 18.8778 52.2425 18.6761C52.555 18.4716 52.9585 18.3693 53.4528 18.3693C53.896 18.3693 54.2837 18.4602 54.6161 18.642C54.9485 18.821 55.207 19.0938 55.3917 19.4602C55.5763 19.8239 55.6687 20.2841 55.6687 20.8409V25H54.663V20.9091C54.663 20.3949 54.5295 19.9943 54.2624 19.7074C53.9954 19.4176 53.6289 19.2727 53.163 19.2727C52.842 19.2727 52.555 19.3423 52.3022 19.4815C52.0522 19.6207 51.8548 19.8239 51.7099 20.0909C51.565 20.358 51.4925 20.6818 51.4925 21.0625ZM57.5064 25V18.4545H58.5121V25H57.5064ZM58.0178 17.3636C57.8217 17.3636 57.6527 17.2969 57.5107 17.1634C57.3714 17.0298 57.3018 16.8693 57.3018 16.6818C57.3018 16.4943 57.3714 16.3338 57.5107 16.2003C57.6527 16.0668 57.8217 16 58.0178 16C58.2138 16 58.3814 16.0668 58.5206 16.2003C58.6626 16.3338 58.7337 16.4943 58.7337 16.6818C58.7337 16.8693 58.6626 17.0298 58.5206 17.1634C58.3814 17.2969 58.2138 17.3636 58.0178 17.3636Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67.2022C43.0717 63.7021 46.9611 58.3105 49.0713 57.3008C50.6502 57.2168 52.1533 56.94 52.4123 57.5979C52.7785 58.5285 51.1995 58.6126 50.4521 59.4441C50.8184 60.3746 51.7159 60.3796 51.6499 61.122C51.3677 61.7704 51.4867 62.9568 51.4518 63.3493C51.4169 63.7417 49.2475 64.575 47.7297 64.8142C47.4755 65.9888 46.8117 68.1723 46 67.2022Z",
    fill: "#AFBEB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4244 63.685C44.692 61.8239 45.7823 60.1495 47.0374 59.3782C48.0121 59.2017 47.1049 59.888 47.3004 60.26C47.5768 60.7861 47.7658 60.0768 48.0073 60.547C48.2838 61.0731 47.8514 61.2074 47.8498 61.6559C47.7092 62.0654 47.7516 62.5325 47.7507 62.7695C47.7499 63.0065 47.5323 63.7059 46.6037 63.97C46.5086 64.6898 45.9818 64.2015 45.4284 63.6887L45.4244 63.685Z",
    fill: "#778B79"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepperoni);
export default __webpack_public_path__ + "static/media/pepperoni.38e915612fe8f8ee58110a1f9094a592.svg";
export { ForwardRef as ReactComponent };